export const statuses = {
  pending: 'pending',
  loading: 'loading',
  failed: 'failed',
  completed: 'completed',
};
